export default {
  colors: {
    primary: '#1B4D6B',
    primaryHover: '#163B52',
    secondary: '#E0733D',
    secondaryHover: '#CC5F2A',
    tertiary: '#2C3941',

    black: '#233237',
    white: '#FFFFFF',
    grayLight: '#F5F7FA',
    gray: '#D8D6DE',
    orange: '#E0733D',
    rose: '#E1B7AD',
    lightYellow: '#EEEADE',
    blue: '#0AA1D0',
    red: '#EA5455',
    brown: '#DA8300',

    surface: '#FFFFFF',
    background: '#F5F7FA',
    textPrimary: '#1F2933',
    textSecondary: '#4B5563',
    textMuted: '#6B7280',
    border: '#D7DDE3',
    borderStrong: '#C2CBD4',
    focus: '#2E90FA',

    success: '#1F9D55',
    info: '#1D72B8',
    warning: '#D97706',
    danger: '#D64545'
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    sizes: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      display: '32px'
    },
    weights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    },
    lineHeights: {
      xs: '16px',
      sm: '20px',
      md: '24px',
      lg: '28px',
      xl: '32px',
      display: '40px'
    }
  },
  spacing: {
    xxs: '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '20px',
    xl: '24px',
    xxl: '32px',
    xxxl: '40px'
  },
  radii: {
    sm: '6px',
    md: '8px',
    lg: '12px',
    pill: '999px'
  },
  shadows: {
    xs: '0 1px 2px rgba(15, 23, 42, 0.08)',
    sm: '0 2px 8px rgba(15, 23, 42, 0.12)',
    md: '0 8px 24px rgba(15, 23, 42, 0.14)'
  }
};
